// Самолечение оболочки при провале ленивого чанка (19 авг 2026).
//
// Класс: у человека на руках старая оболочка (SW-precache или вкладка, открытая
// через деплой), её ленивый импорт просит чанк прошлой сборки. Сервер держит
// историю ассетов 30 суток (том panel_assets), поэтому в норме класс закрыт
// инфраструктурой; этот модуль — последний рубеж для оболочек СТАРШЕ истории
// и любых иных провалов подгрузки (штатный приём Vite: событие
// `vite:preloadError`, docs/guide/build → Load Error Handling).
//
// Контракт: первый провал → метка в sessionStorage + beacon chunk_reload +
// однократная перезагрузка (свежий index → свежие чанки). Повторный провал в
// окне минуты — НЕ перезагружаемся (сервер реально болен, цикл запрещён):
// ошибку не гасим (без preventDefault) — она долетает до ErrorBoundary, там
// штатная крашкарта + beacon client-error. sessionStorage недоступен → тоже не
// перезагружаемся: без замка цикл возможен, крашкарта честнее.

const RELOAD_AT_KEY = 'padla_chunk_reload_at';
const LOOP_WINDOW_MS = 60_000;

/** Чистая логика замка: перезагружаться ли при провале сейчас. */
export function shouldReload(nowMs: number, prevReloadAtMs: number | null): boolean {
  if (prevReloadAtMs === null || Number.isNaN(prevReloadAtMs)) return true;
  return nowMs - prevReloadAtMs > LOOP_WINDOW_MS;
}

/** Вешает обработчик vite:preloadError. Зовётся один раз из main.tsx до рендера. */
export function installChunkReload(): void {
  window.addEventListener('vite:preloadError', () => {
    let allowed = false;
    try {
      const raw = sessionStorage.getItem(RELOAD_AT_KEY);
      allowed = shouldReload(Date.now(), raw === null ? null : Number(raw));
      if (allowed) sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
    } catch {
      allowed = false; // storage недоступен — замка нет, цикл запрещён (П5)
    }
    if (!allowed) return; // ошибка уйдёт в ErrorBoundary штатным путём
    try {
      // Blob с type application/json — иначе sendBeacon шлёт text/plain
      // (см. коммент в index.html про недосчёт boot_started, баг 1 июл).
      navigator.sendBeacon(
        '/api/v1/miniapp/rum',
        new Blob([JSON.stringify({ type: 'chunk_reload' })], { type: 'application/json' })
      );
    } catch {
      // Метрика никогда не мешает лечению.
    }
    window.location.reload();
  });
}
